import { render, staticRenderFns } from "./event_tab_component.vue?vue&type=template&id=2b0a13c0&scoped=true&"
import script from "./event_tab_component.vue?vue&type=script&lang=js&"
export * from "./event_tab_component.vue?vue&type=script&lang=js&"
import style0 from "./event_tab_component.vue?vue&type=style&index=0&id=2b0a13c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a13c0",
  null
  
)

export default component.exports